import { useDomainConfig } from 'context/DomainConfigProvider/DomainConfigProvider';
import { isDomainLocale } from 'helpers/isDomainLocale';

export const useCustomerUserAddressFormFieldOrder = () => {
    const { defaultLocale } = useDomainConfig();
    const isGermanLocale = isDomainLocale(defaultLocale, 'de');
    const isAustriaLocale = isDomainLocale(defaultLocale, 'de-AT');

    return {
        city: isGermanLocale || isAustriaLocale ? 2 : 1,
        zip: isGermanLocale || isAustriaLocale ? 1 : 2,
    };
};
